import { useAppSelector } from "features/store";
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { canEditBotNotes } from "utils/roles";

/** Gate for the standalone notes screen: whoever may edit the notes. */
const BotNotesRoute = ({ children }: { children: ReactNode }): JSX.Element => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (user && !user.is_pass_reset)
    return <Navigate to="/reset-password" replace />;
  if (!user || !canEditBotNotes(user.platform_profile))
    return <Navigate to="/" replace />;
  return <>{children}</>;
};

export default BotNotesRoute;
